import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class EntitlementGuard
   {

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.checkEntitlements();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.checkEntitlements();
  }

  canLoad(route: Route): boolean {
    return this.checkEntitlements();
  }

  checkEntitlements() {
    // Assume anything without a corresponding navigation item and entitlement can be accessed
    // TODO: Determine if this is always the case and re-evaluate if needed.
    return true;
  }

}
